export const items = [
    {
      id: 1,
      name: "Compost Bin",
      price: 2000,
      description: "Eco-friendly compost bin.",
      img: "/assets/compost_bin.png",
      category: "collection",
    },
    {
      id: 2,
      name: "Recycling Bags",
      price: 250,
      description: "Reusable recycling bags.",
      img: "/assets/recycle_bins.png",
      category: "collection",
    },
    {
      id: 3,
      name: "Gloves",
      price: 350,
      description: "Durable gloves for cleanups.",
      img: "/assets/gloves.png",
      category: "safety",
    },
    {
      id: 4,
      name: "Trash Picker",
      price: 1200,
      description: "Ergonomic trash picker.",
      img: "/assets/trash_collector.png",
      category: "collection",
    },
    {
      id: 5,
      name: "Recyclable Bin",
      price: 2400,
      description: "Separate bin for recyclables.",
      img: "/assets/recyclable_bins.png",
      category: "collection",
    },
    {
      id: 6,
      name: "Safety Vest",
      price: 960,
      description: "Reflective safety vest.",
      img: "/assets/vests.png",
      category: "safety",
    },
    {
      id: 7,
      name: "Face Mask",
      price: 349,
      description: "Breathable face mask.",
      img: "/assets/masks.png",
      category: "hygiene",
    },
    {
      id: 8,
      name: "Hand Sanitizer",
      price: 100,
      description: "Portable hand sanitizer.",
      img: "/assets/sanitiser.png",
      category: "hygiene",
    },
    {
      id: 9,
      name: "Water Bottle",
      price: 100,
      description: "Reusable water bottle.",
      img: "/assets/bottle.png",
      category: "essentials",
    },
    {
      id: 10,
      name: "Eco Bag",
      price: 560,
      description: "Reusable shopping bag.",
      img: "/assets/bags.png",
      category: "essentials",
    },
  ];
  
 export const categories = [
    { id: "all", label: "All Products" },
    { id: "collection", label: "Collection Tools" },
    { id: "safety", label: "Safety Gear" },
    { id: "hygiene", label: "Hygiene" },
    { id: "essentials", label: "Essentials" },
  ];